import { createContext } from 'react';
import * as client from 'src/configs/client';

const ClientConfigContext = createContext<client.types.Config>(client.constants.unit);

const { Provider: ClientConfigProvider } = ClientConfigContext;

export { ClientConfigContext, ClientConfigProvider };
